export const rejectedOnStatusOptions = [
  { value: "IMPLEMENTER", label: "Implementadora" },
  { value: "PROJECT", label: "Unidad de proyectos" },
  { value: "LOCAL_COUNCIL", label: "Consejo local" },
  { value: "DIRECTIVE_COUNCIL", label: "Consejo directivo" },
  { value: "TECHNICAL_COMMITTEE", label: "Comité Técnico" }
]

export const REJECT_ON_STATUS_LABEL = {
  IMPLEMENTER: "Implementadora",
  PROJECT: "Unidad de proyectos",
  LOCAL_COUNCIL: "Consejo local",
  DIRECTIVE_COUNCIL: "Consejo directivo",
  TECHNICAL_COMMITTEE: "Comité Técnico"
}






